import type {
  Proposal,
  Decision,
  TransferSummary,
} from 'src/services/DataVaultTransfer.service';

export interface TransferPageState {
  status:
    | 'loading'
    | 'error'
    | 'no_candidates'
    | 'pending'
    | 'committing'
    | 'committed';
  transferId: number | null;
  proposals: Proposal[];
  decisions: Map<string, Decision>; // key: `${qit_id}_${instance_index}`
  summary: TransferSummary | null;
  error: string | null;
}

export function decisionKey(qitId: number, instanceIndex: number): string {
  return `${qitId}_${instanceIndex}`;
}
